import React, { useState, useEffect } from "react";
import { sidebarPanelStyle } from "../constants/sidebarLayout";

const MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: CURRENT_YEAR - 1989 + 10 }, (_, i) => 1990 + i);

const selectStyle = {
  padding: "5px 4px",
  fontSize: "11px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  background: "#fff",
  color: "#111",
  cursor: "pointer",
  minWidth: 0,
};

function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

function dateToParts(date) {
  if (!date) {
    return { month: 1, day: 1, year: CURRENT_YEAR };
  }
  return {
    month: date.getMonth() + 1,
    day: date.getDate(),
    year: date.getFullYear(),
  };
}

function buildDate({ month, day, year }) {
  const maxDay = getDaysInMonth(month, year);
  const date = new Date(year, month - 1, Math.min(day, maxDay));
  date.setHours(0, 0, 0, 0);
  return date;
}

function DateSelects({ parts, onChange }) {
  const { month, day, year } = parts;
  const daysInMonth = getDaysInMonth(month, year);
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const handleMonthChange = (e) => {
    const newMonth = Number(e.target.value);
    const maxDay = getDaysInMonth(newMonth, year);
    onChange({ month: newMonth, day: Math.min(day, maxDay), year });
  };

  const handleDayChange = (e) => {
    onChange({ month, day: Number(e.target.value), year });
  };

  const handleYearChange = (e) => {
    const newYear = Number(e.target.value);
    const maxDay = getDaysInMonth(month, newYear);
    onChange({ month, day: Math.min(day, maxDay), year: newYear });
  };

  return (
    <div style={{ display: "flex", gap: "4px", width: "100%" }}>
      <select value={month} onChange={handleMonthChange} style={{ ...selectStyle, flex: 1.4 }}>
        {MONTHS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select value={day} onChange={handleDayChange} style={{ ...selectStyle, flex: 0.7 }}>
        {days.map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </select>
      <select value={year} onChange={handleYearChange} style={{ ...selectStyle, flex: 1 }}>
        {YEARS.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function CustomDatePicker({ startDate, endDate, setStartDate, setEndDate, onSubmit }) {
  const [tempStart, setTempStart] = useState(() => dateToParts(startDate));
  const [tempEnd, setTempEnd] = useState(() => dateToParts(endDate));

  useEffect(() => {
    setTempStart(dateToParts(startDate));
  }, [startDate]);

  useEffect(() => {
    setTempEnd(dateToParts(endDate));
  }, [endDate]);

  const handleSubmit = () => {
    setStartDate(buildDate(tempStart));
    setEndDate(buildDate(tempEnd));
    if (onSubmit) onSubmit();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "6px",
        ...sidebarPanelStyle,
        margin: "0 auto",
      }}
    >
      <DateSelects parts={tempStart} onChange={setTempStart} />
      <DateSelects parts={tempEnd} onChange={setTempEnd} />
      <button
        type="button"
        onClick={handleSubmit}
        style={{
          width: "100%",
          marginTop: "2px",
          padding: "6px 12px",
          fontSize: "11px",
          fontWeight: 500,
          borderRadius: "4px",
          border: "1px solid #bbb",
          background: "rgba(255, 255, 255, 0.9)",
          color: "#111",
          cursor: "pointer",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.15)",
        }}
      >
        Submit
      </button>
    </div>
  );
}
